import React from 'react';
import { SECTION_ACCENT, RADIUS } from '../../config/designTokens';
export interface SectionHeaderProps {
  title: string;
  description?: string;
  icon?: React.ElementType;
  accentColor?: string;
  action?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function SectionHeader({
  title,
  description,
  icon: Icon,
  accentColor = SECTION_ACCENT.default,
  action,
  size = 'md',
  className = ''
}: SectionHeaderProps) {
  // Extract colors from accentColor (e.g., 'bg-blue-100 text-blue-600')
  const bgClass = accentColor.split(' ').find(c => c.startsWith('bg-')) || 'bg-indigo-100';
  const textClass = accentColor.split(' ').find(c => c.startsWith('text-')) || 'text-indigo-600';
  // Size configurations
  const sizes = {
    sm: {
      chip: `w-10 h-10 ${RADIUS.pill}`,
      icon: 'w-5 h-5',
      title: 'text-lg font-bold text-slate-900',
      container: 'gap-3',
      Heading: 'h3' as const
    },
    md: {
      chip: `w-12 h-12 ${RADIUS.button}`,
      icon: 'w-6 h-6',
      title: 'text-xl font-bold text-slate-900',
      container: 'gap-4',
      Heading: 'h2' as const
    },
    lg: {
      chip: `w-16 h-16 ${RADIUS.card} transform -rotate-6 shadow-md`,
      icon: 'w-8 h-8',
      title: `text-3xl font-black ${textClass.replace('-600', '-900')} tracking-tight drop-shadow-sm`,
      container: 'gap-5',
      Heading: 'h2' as const
    }
  };
  const config = sizes[size];
  const Heading = config.Heading;
  return <div className={`flex items-center justify-between ${className}`} data-id="element-2656">
      <div className={`flex items-center ${config.container}`} data-id="element-2657">
        {Icon && <div className={`${config.chip} ${bgClass} flex items-center justify-center ${textClass} flex-shrink-0`} data-id="element-2658">
            <Icon className={config.icon} strokeWidth={size === 'lg' ? 2.5 : 2} data-id="element-2659" />
          </div>}
        <div data-id="element-2660">
          <Heading className={config.title} data-id="element-2661">{title}</Heading>
          {description && <p className="text-sm text-slate-500 mt-0.5" data-id="element-2662">{description}</p>}
        </div>
      </div>
      {action && <div className="flex-shrink-0 ml-4" data-id="element-2663">{action}</div>}
    </div>;
}